import { render, staticRenderFns } from "./HistoryItemJob_career.vue?vue&type=template&id=0ed31d20&scoped=true"
import script from "./HistoryItemJob_career.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryItemJob_career.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryItemJob_career.vue?vue&type=style&index=0&id=0ed31d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed31d20",
  null
  
)

export default component.exports